// extracted by mini-css-extract-plugin
export default {"pageWrap":"Bc-z","fullWidth":"Cc-z","heading":"Dc-z","fullBleed":"Ec-z","hidden":"Fc-z"};